module.exports = __webpack_public_path__ + "static/media/Nunito-BoldItalic.534bd4bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Nunito/Nunito-BoldItalic.ttf
// module id = 303
// module chunks = 0